import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function(params) {
      return qs.stringify(params, { encode: false });
    }
  };

  return axios.get(`${url}/boletos`, options).then(response => {
    return {
      list: response.data.data, 
      meta: response.data.meta
    };
  });
}

function getInfo(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/boletos/infoBoleto/${id}`, options)
    .then(response => {
      return response.data.data;
    });
}

function verificacion(permiso) {
  const payload = {
    data: permiso,
  };
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/verificarPermiso`, payload, options)
    .then(response => {
      return response.data;
    });
}

function autorizacion(auth) {
  const payload = {
    data: auth,
  };
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/solicitarAutorizacion`, payload, options)
    .then(response => {
      return response.data;
    });
}

function autorizacionToken(auth) {
  const payload = {
    data: auth,
  };
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/solicitarAutorizacionConToken`, payload, options)
    .then(response => {
      return response.data;
    });
}

function anulaBoleto(boleto) {
  const payload = jsona.serialize({
    stuff: boleto,
    includeNames: null
  });
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/boletos/anularBoleto`, payload, options)
    .then(response => {
      return response.data;
    });
}
function reimprimeBoleto(boleto) {
  const payload = jsona.serialize({
    stuff: boleto,
    includeNames: null
  });
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/boletos/reimprimirBoleto`, payload, options)
    .then(response => {
      return response.data;
    });
}

function cambiaNombrePasajeroBoleto(boleto) {
  const payload = jsona.serialize({
    stuff: boleto,
    includeNames: null
  });
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/boletos/editarPasajero`, payload, options)
    .then(response => {
      return response.data;
    });
}

function veReserva(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/boletos/verReserva/${id}`, options)
    .then(response => {
      return response.data.data;
    });
}

function confirmaReserva(boleto) {
  const payload = jsona.serialize({
    stuff: boleto,
    includeNames: null
  });
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/boletos/confirmarReserva`, payload, options)
    .then(response => {
      return response.data;
    });
}

function anulaReserva(boleto) {
  const payload = jsona.serialize({
    stuff: boleto,
    includeNames: null
  });
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/boletos/anularReserva`, payload, options)
    .then(response => {
      return response.data;
    });
}

function vendeEquipajeExtra(boleto) {
  const payload = jsona.serialize({
    stuff: boleto,
    includeNames: null
  });
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/boletos/venderEquipajeExtra`, payload, options)
    .then(response => {
      return response.data;
    });
}
function crearToken(canal) {
  const payload = {
    data: canal
  };
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/crearTokenVenta`, payload, options)
    .then(response => {
      return response.data;
    });
}
function canjeBoleto(boleto) {
  const payload = jsona.serialize({
    stuff: boleto,
    includeNames: null
  });
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/boletos/canjearBoleto`, payload, options)
    .then(response => {
      return response.data;
    });
}

function getboletosParaAnular(params) {
  const options = {
      headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
      }
  };
  
  return axios
      .get(`${url}/boletos/boletosParaAnular?numero_asiento=${params.numero_asiento}&subcorrida_id=${params.subcorrida_id}`, options)
      .then(response => {
          return response.data.data;
      });
}

export default {
  list,
  getInfo,
  verificacion,
  autorizacion,
  autorizacionToken,
  anulaBoleto,
  reimprimeBoleto,
  cambiaNombrePasajeroBoleto,
  veReserva,
  confirmaReserva,
  anulaReserva,
  vendeEquipajeExtra,
  crearToken,
  canjeBoleto,
  getboletosParaAnular
};
